module.exports = __webpack_public_path__ + "img/vert-5.e6283b4c.png";